





































































































import { Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store'

@Component
export default class UserFaq extends Vue {
  // data
  private activeFaq: string = ''

  // computed
  get faqData() {
    return vxm.faq.faqEn
  }

  // method
  setActiveFaq(index: number, subIndex: number, qaIndex: number) {
    const newActiveFaq = index + '.' + subIndex + '.' + qaIndex
    if (this.activeFaq === newActiveFaq) this.activeFaq = ''
    else this.activeFaq = newActiveFaq
  }

  // Lifecycle hooks
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
